export default "__VITE_ASSET__ChRxakNg__"